import {useState} from "react"
import {Input, Select, Button} from "antd"
import {EyeOff, Plus} from "lucide-react"
import "./MarketFieldsComponent.scss"
import {APIv1} from "../../../../api";
import {withPrefilledOption} from "../../../../utils/device/deviceUtils";

const regionOptions = [
    {label: "Andijan", value: "ANDIJAN"},
    {label: "Bukhara", value: "BUKHARA"},
    {label: "Fergana", value: "FERGANA"},
    {label: "Jizzakh", value: "JIZZAKH"},
    {label: "Namangan", value: "NAMANGAN"},
    {label: "Navoiy", value: "NAVOIY"},
    {label: "Qashqadaryo", value: "QASHQADARYO"},
    {label: "Karakalpakstan", value: "KARAKALPAKSTAN"},
    {label: "Samarqand", value: "SAMARQAND"},
    {label: "Sirdaryo", value: "SIRDARYO"},
    {label: "Surxondaryo", value: "SURXONDARYO"},
    {label: "Tashkent", value: "TASHKENT"},
];

const MarketFieldsComponent = ({
    t,
    data,
    onChange,
    userData,
    disabled = false,
    canEditField = () => true,
}) => {
    const [showAdditionalFields, setShowAdditionalFields] = useState(false)
    const [deviceMarkets, setDeviceMarkets] = useState([]);
    const [marketDistrict, setMarketDistrict] = useState([]);
    const [loading, setLoading] = useState(false);

    const fetchMarket = async () => {
        setLoading(true);
        try {
            const marketResponse = await APIv1.get('/market/list/name/', {
                headers: {
                    Authorization: `Token ${userData.token}`
                },
            });
            setDeviceMarkets(marketResponse.data.map(item => ({
                value: item.id,
                label: item.name,
            })))
        } catch (err) {
            console.error('Something went wrong with users:', err);
        } finally {
            setLoading(false);
        }
    }

    const fetchMarketDistrict = async () => {
        try {
            setLoading(true);
            const districtResponse = await APIv1.get('/market/list/district/', {
                headers: {
                    Authorization: `Token ${userData.token}`
                },
            });
            setMarketDistrict(
                districtResponse.data.map(item => ({
                    value: item.id,
                    label: item.name,
                })))
        } catch (err) {
            console.error("Something went wrong with companies:", err);
        } finally {
            setLoading(false);
        }
    };


    const handlePlusClick = () => {
        if (disabled || !canEditField('market_id')) return
        setShowAdditionalFields(true)
    }

    const hideAdditionalFields = () => {
        setShowAdditionalFields(false)
    }

    return (
        <div className="market-fields-container">
            <div className="market-fields-left">
                <div className="create-device__field">
                    <div className="create-device__field-label">
                        <span className="create-device__required-label">{t("pages.devices.addNewDeviceColumns.marketFields.row1")}</span>
                    </div>
                    <div className="create-device__inline-control">
                        <Select
                            className="create-device__control"
                            placeholder={t("pages.devices.addNewDeviceColumns.placeholders.row11")}
                            optionLabelProp="label"
                            options={deviceMarkets}
                            allowClear
                            autoFocus
                            disabled={disabled || !canEditField('market_id')}
                            value={data.market_id ? {
                                value: data.market_id,
                                label: data.market_name
                            } : undefined}
                            onChange={(val) => {
                                if (!val) {
                                    onChange({market_id: null, market_name: ""});
                                    return;
                                }
                                onChange({market_id: val.value, market_name: val.label});
                            }}
                            labelInValue
                            dropdownMatchSelectWidth={false}
                            showArrow
                            showSearch
                            loading={loading}
                            filterOption={(input, option) =>
                                option?.label?.toLowerCase().includes(input.toLowerCase())
                            }
                            onDropdownVisibleChange={(open) => {
                                if (open && deviceMarkets.length === 0) {
                                    fetchMarket();
                                }
                            }}
                        />
                        <Button className="create-device__icon-button" icon={<Plus size={16}/>} onClick={handlePlusClick} disabled={disabled || !canEditField('market_id')}/>
                    </div>
                </div>
            </div>

            {showAdditionalFields && (
                <div className="market-fields-right">
                    <div className="market-fields-controls">
                        <Button
                            type="text"
                            icon={<EyeOff size={16}/>}
                            onClick={hideAdditionalFields}
                            className="toggle-left-button"
                        >
                            {t("pages.devices.addNewDeviceColumns.marketFields.button1")}
                        </Button>
                    </div>

                    <div className="create-device__field-grid create-device__field-grid--compact">
                        <div className="create-device__field">
                            <div className="create-device__field-label">{t("pages.devices.addNewDeviceColumns.marketFields.row2")}</div>
                            <Input
                                className="create-device__control"
                                placeholder="text"
                                allowClear
                                disabled={disabled || !canEditField('market_name')}
                                value={data.market_name || ""}
                                onChange={(e) => onChange({market_name: e.target.value})}
                            />
                        </div>
                        <div className="create-device__field">
                            <div className="create-device__field-label">{t("pages.devices.addNewDeviceColumns.marketFields.row3")}</div>
                            <Select
                                className="create-device__control"
                                placeholder={t("pages.devices.addNewDeviceColumns.placeholders.row13")}
                                optionLabelProp="label"
                                options={regionOptions}
                                allowClear={true}
                                autoFocus={true}
                                virtual={false}
                                disabled={disabled || !canEditField('region')}
                                value={data.region || undefined}
                                onChange={(value) => onChange({region: value})}
                            />
                        </div>
                        <div className="create-device__field">
                            <div className="create-device__field-label">{t("pages.devices.addNewDeviceColumns.marketFields.row4")}</div>
                            <Select
                                className="create-device__control"
                                placeholder={t("pages.devices.addNewDeviceColumns.placeholders.row14")}
                                value={data.district_name ?? undefined}
                                disabled={disabled || !canEditField('district_name')}
                                onChange={(value, option) => onChange({district_name: option?.label})}
                                options={withPrefilledOption(marketDistrict, data.district_id, data.district_name)}
                                optionLabelProp="label"
                                showSearch
                                virtual={false}
                                dropdownMatchSelectWidth={false}
                                filterOption={(input, option) =>
                                    option?.label?.toLowerCase().includes(input.toLowerCase())
                                }
                                loading={loading}
                                onDropdownVisibleChange={(open) => {
                                    if (open && marketDistrict.length === 0) {
                                        fetchMarketDistrict();
                                    }
                                }}
                            />
                        </div>
                        <div className="create-device__field">
                            <div className="create-device__field-label">{t("pages.devices.addNewDeviceColumns.marketFields.row5")}</div>
                            <Input
                                className="create-device__control"
                                placeholder="text"
                                allowClear
                                disabled={disabled || !canEditField('lat')}
                                value={data.lat || 0.0}
                                onChange={(e) => {
                                    const raw = e.target.value.replace(",", ".");
                                    onChange({lat: raw ? parseFloat(raw) : null});
                                }}
                            />
                        </div>
                        <div className="create-device__field">
                            <div className="create-device__field-label">{t("pages.devices.addNewDeviceColumns.marketFields.row6")}</div>
                            <Input
                                className="create-device__control"
                                placeholder="text"
                                allowClear
                                disabled={disabled || !canEditField('long')}
                                value={data.long || 0.0}
                                onChange={(e) => {
                                    const raw = e.target.value.replace(",", ".");
                                    onChange({long: raw ? parseFloat(raw) : null});
                                }}
                            />
                        </div>
                    </div>
                </div>
            )}
        </div>
    )
}

export default MarketFieldsComponent
